module.exports = __webpack_public_path__ + "img/2.3b56f7e0.png";